import styled from "styled-components"

export const HeroContainer = styled.div`
  height: 600px;
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: cover !important;
  position: relative;
  transition: 0.3s ease;
`

export const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 65, 106, 0.6);
`

export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`
export const Content = styled.div`
  max-width: 900px;
  text-align: center;
  color: ${props => props.theme.colors.white};
  h1 {
    color: ${props => props.theme.colors.white};
    font-weight: 300;
    text-transform: uppercase;
    margin-bottom: 25px;
    transtition: 0.3s ease;
    @media (max-width: 575px) {
      font-size: 24px;
    }
  }
  p {
    margin-bottom: 40px;
  }
  a {
    border: 2px solid ${props => props.theme.colors.white};
    padding: 8px 16px;
    border-radius: 4px;
    color: ${props => props.theme.colors.white};
    text-decoration: none;
    transition: 0.3s ease;
    font-weight: 500;
    &:hover {
      background-color: ${props => props.theme.colors.darkBlue};
      // border: 1px solid ${props => props.theme.colors.darkBlue};
    }
  }
`
